"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _LiquidPixelVisualizer = require("./LiquidPixelVisualizer.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-unused-expressions */
var aspectRatio = {
  height: 9,
  width: 16
};
var lpContainerId = 'destination';
var magnifyLoading = false;
var readyTimer;

var loadZoom = function loadZoom(callback) {
  var _com$liquidpixels, _com$liquidpixels2;

  var _window = window,
      com = _window.com;

  if (!(com !== null && com !== void 0 && (_com$liquidpixels = com.liquidpixels) !== null && _com$liquidpixels !== void 0 && _com$liquidpixels.Zoom) && !magnifyLoading) {
    magnifyLoading = true;
    (0, _autobahnUtilities.getScript)('https://blinds.liquifire.com/zap/dhtml/com.liquidpixels.Zoom.jsr').then(function () {
      callback === null || callback === void 0 ? void 0 : callback();
    });
  } else if (com !== null && com !== void 0 && (_com$liquidpixels2 = com.liquidpixels) !== null && _com$liquidpixels2 !== void 0 && _com$liquidpixels2.Zoom) {
    callback === null || callback === void 0 ? void 0 : callback();
  }
};

var clearTimer = function clearTimer() {
  if (readyTimer) {
    clearTimeout(readyTimer);
    readyTimer = null;
  }
};

var LiquidPixelVisualizer = function LiquidPixelVisualizer(_ref) {
  var baseDomain = _ref.baseDomain,
      className = _ref.className,
      chain = _ref.chain,
      minimized = _ref.minimized,
      visualizationCallback = _ref.visualizationCallback,
      zoomEnabled = _ref.zoomEnabled;
  var visualizerRef = (0, _react.useRef)(null);
  var zoomRef = (0, _react.useRef)();
  var chainRef = (0, _react.useRef)();
  var minRef = (0, _react.useRef)();
  var visualizerContainerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      viewer = _useState2[0],
      setViewer = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isInitializing = _useState4[0],
      setIsInitializing = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isInitialized = _useState6[0],
      setIsInitialized = _useState6[1];

  (0, _react.useEffect)(function () {
    zoomRef.current = zoomEnabled;
    chainRef.current = chain;
    minRef.current = minimized;
  });
  var prevZoomState = zoomRef.current;
  var prevChain = chainRef.current;
  var prevMinState = minRef.current;

  var handleErrorState = function handleErrorState() {
    setIsInitializing(false);
    setIsInitialized(true);
    visualizationCallback({
      visualized: false
    });
  };

  var handleContainerSizeChanges = (0, _debounce["default"])(function () {
    var _visualizerContainerR;

    var iFrame = (_visualizerContainerR = visualizerContainerRef.current) === null || _visualizerContainerR === void 0 ? void 0 : _visualizerContainerR.querySelector('iframe'); // The existence of an IFrame lets us know LP has actually done it's setup.

    if (iFrame) {
      var offsetWidth = visualizerContainerRef.current.offsetWidth;
      var frameWidth = iFrame.offsetWidth;

      if (Math.ceil(frameWidth) !== Math.ceil(offsetWidth)) {
        // Remove existing viewer (of the wrong size)
        if (viewer) {
          viewer.DESTROY();
        }

        setViewer(null); // Re-initialize viewer after size transition is complete

        setIsInitialized(false);
      }
    }
  }, 200); // This intentionally manages it's own update routine to avoid update loops from long dependency lists
  // eslint-disable-next-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (!viewer && chain && baseDomain && !isInitializing) {
      setIsInitializing(true); // LP doesn't appear to clean up it's iFrame, this prevents infinite loops.

      var iFrame = visualizerContainerRef.current.querySelector('iframe');
      if (iFrame) iFrame.remove();
      loadZoom(function () {
        var _visualizerContainerR2 = visualizerContainerRef.current,
            offsetHeight = _visualizerContainerR2.offsetHeight,
            offsetWidth = _visualizerContainerR2.offsetWidth;
        var _window2 = window,
            com = _window2.com;
        setViewer(new com.liquidpixels.Zoom(lpContainerId, {
          chain: chain,
          description: 'Interior',
          displayMode: 'fill',
          height: Math.ceil(offsetHeight),
          port: '80',
          server: baseDomain,
          stitched: true,
          uri: 'blinds',
          width: Math.ceil(offsetWidth),
          zoomFactor: 1,
          // This specific number disables the click to zoom functionlity
          homeIcon: false,
          // This both hides the LP home button and causes viewer.home() to fail
          displayError: true,
          // This currently forces LP to provide us an image and error message.
          handleEvent: function handleEvent(eventName) {
            clearTimer();

            if (eventName === 'loaded') {
              setIsInitialized(true);
              visualizationCallback({
                visualized: true,
                loaded: true
              });
              setTimeout(handleContainerSizeChanges, 100);
            } else if (eventName === 'started') {
              // At this point LP can handle itself and be detroyed if needed
              setIsInitializing(false);
              readyTimer = setTimeout(handleErrorState, 10000);
            } else if (eventName === 'ready') {
              // Sometimes we hit ready state but 500 response doesn't generate further events
              // So set a timeout for max load time and if we haven't cleared it go to error state anyway.
              readyTimer = setTimeout(handleErrorState, 10000);
            } else if (eventName === 'error') {
              handleErrorState();
            }
          }
        }));
      });
    }
  }); // This intentionally manages it's own update routine to avoid update loops from long dependency lists
  // eslint-disable-next-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(function () {
    if (isInitialized && viewer && chain !== prevChain) {
      setIsInitialized(false);
      clearTimer();
      readyTimer = setTimeout(handleErrorState, 10000);
      viewer.loadChain(chain);
    }
  });
  (0, _react.useEffect)(function () {
    if (isInitialized && viewer && prevZoomState !== zoomEnabled) {
      if (zoomEnabled) {
        viewer.zoomIn(4);
      } else {
        viewer.zoomOut(0.25);
      }
    }
  });
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', function () {
      handleContainerSizeChanges();
    });
  }, [handleContainerSizeChanges]);
  (0, _react.useEffect)(function () {
    if (prevMinState !== minimized) {
      handleContainerSizeChanges();
    }
  }, [handleContainerSizeChanges, minimized, prevMinState]);
  return /*#__PURE__*/_react["default"].createElement(_LiquidPixelVisualizer.StyledLiquidPixelVisualizer, {
    className: className,
    "data-id": "visualizer",
    ref: visualizerRef
  }, /*#__PURE__*/_react["default"].createElement(_LiquidPixelVisualizer.StyledLiquidPixelVisualizerRatioBox, {
    ratio: aspectRatio
  }, /*#__PURE__*/_react["default"].createElement(_LiquidPixelVisualizer.StyledLiquidPixelVisualizerWrapper, {
    chain: chain
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: visualizerContainerRef,
    id: lpContainerId
  }))));
};

LiquidPixelVisualizer.defaultProps = {
  baseDomain: 'blinds.liquifire.com',
  className: null,
  chain: null,
  minimized: true,
  visualizationCallback: function visualizationCallback() {},
  zoomEnabled: true
};
LiquidPixelVisualizer.propTypes = {
  /** Base domain of the LP server */
  baseDomain: _propTypes.string,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Full LP Chain to render */
  chain: _propTypes.string,

  /** If true, the visualizer will render a zoomed version of the Image */
  zoomEnabled: _propTypes.bool,

  /** Callback for when viewer interaction or state needs to update the container */
  visualizationCallback: _propTypes.func,

  /*
   * If true, the visualizer will update for a smaller scale
   * LP requires that we remove and re-add the viewer on size change.
   * This include the minimization transistion.
   */
  minimized: _propTypes.bool
};
LiquidPixelVisualizer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LiquidPixelVisualizer",
  "props": {
    "baseDomain": {
      "defaultValue": {
        "value": "'blinds.liquifire.com'",
        "computed": false
      },
      "description": "Base domain of the LP server",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "chain": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Full LP Chain to render",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "minimized": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "visualizationCallback": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Callback for when viewer interaction or state needs to update the container",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "zoomEnabled": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "If true, the visualizer will render a zoomed version of the Image",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(LiquidPixelVisualizer);

exports["default"] = _default;